import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

/** Rapport des codes qui GARDENT leur préfixe de catalogue (collision avec un
    code existant — demande du propriétaire, 2026-10-20) + bouton pour REJOUER le
    retrait des préfixes (utile sur la PRODUCTION après déploiement : la migration
    de l'aperçu ne s'y applique pas toute seule). */
export default function CodesCollisionsCard({ isAdmin }) {
  const [data, setData] = useState(null);
  const [running, setRunning] = useState(false);

  const charger = () => api.get("/admin/codes-collisions")
    .then((r) => setData(r.data)).catch(() => setData({ collisions: [], nb_collisions: 0, codes_migres: 0 }));
  useEffect(() => { charger(); }, []);

  const relancer = async () => {
    setRunning(true);
    try {
      const { data: res } = await api.post("/admin/migrations/retirer-prefixes-sku");
      toast.success(res.depouilles
        ? `${res.depouilles} codes dépouillés de leur préfixe (${res.gardes.length} gardés — collisions)`
        : `Rien à faire — les codes sont déjà sans préfixe (${res.gardes.length} collisions conservées)`);
      charger();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setRunning(false); }
  };

  if (!data) return null;
  return (
    <div className="bg-surface border border-ivory/10 rounded-xl p-7 mb-6" data-testid="codes-collisions-card">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <p className="font-semibold">Codes sans préfixe — rapport des collisions</p>
          <p className="text-xs text-ivory/70 mt-1">
            {data.codes_migres} codes ont été dépouillés de leur préfixe de catalogue
            (PDU-, TR-, DTC-, CR-, 6-). Les {data.nb_collisions} codes ci-dessous GARDENT leur
            préfixe parce que le code dépouillé existe déjà chez un autre produit — à régler
            un à un dans la fiche produit (changez le code de l'un des deux).
          </p>
        </div>
        {isAdmin && (
          <button type="button" onClick={relancer} disabled={running} data-testid="codes-collisions-relancer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm bg-gold text-ink font-semibold hover:bg-champagne transition-colors disabled:opacity-50">
            {running ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
            Rejouer le retrait des préfixes
          </button>
        )}
      </div>
      {data.nb_collisions > 0 && (
        <ul className="mt-4 space-y-1.5 max-h-80 overflow-y-auto overscroll-contain pr-1" data-lenis-prevent data-testid="codes-collisions-liste">
          {data.collisions.map((p) => (
            <li key={p.id} className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-sm bg-ink/40 border border-ivory/10 rounded-lg px-4 py-2"
              data-testid={`collision-${p.id}`}>
              <span className="font-mono font-semibold text-amber-300">{p.sku}</span>
              <span className="text-ivory/70 flex-1 min-w-40 truncate">{p.name}</span>
              {p.catalogue_no && <span className="text-[10px] text-ivory/40">cat. {p.catalogue_no}</span>}
              <a href={`/produit/${p.id}`} target="_blank" rel="noreferrer"
                className="text-xs text-gold hover:text-champagne underline underline-offset-2 transition-colors">
                Voir la fiche
              </a>
            </li>
          ))}
        </ul>
      )}
      {data.nb_collisions === 0 && (
        <p className="mt-3 text-xs text-emerald-300" data-testid="codes-collisions-vide">Aucune collision — tous les codes sont sans préfixe.</p>
      )}
    </div>
  );
}
